import { reactive } from "vue";

export const modalState = reactive({
  isOpen: false,
  title: "Tasdiqlash",
  message: "Haqiqatan ham bu amalni bajarmoqchimisiz?",
  confirmText: "O'chirish",
  cancelText: "Bekor qilish",
  type: "danger", // 'danger' | 'warning' | 'info' | 'success'
  resolve: null,
  reject: null
});

export function confirmModal(options = {}) {
  return new Promise((resolve) => {
    modalState.title = options.title || "Kafedrani o'chirish";
    modalState.message = options.message || "Haqiqatan ham bu kafedrani o'chirishni xohlaysizmi?";
    modalState.confirmText = options.confirmText || "Ha, o'chirish";
    modalState.cancelText = options.cancelText || "Bekor qilish";
    modalState.type = options.type || "danger";
    modalState.resolve = resolve;
    modalState.isOpen = true;
  });
}

export function handleConfirm() {
  modalState.isOpen = false;
  if (modalState.resolve) {
    modalState.resolve(true);
    modalState.resolve = null;
  }
}

export function handleCancel() {
  modalState.isOpen = false;
  if (modalState.resolve) {
    modalState.resolve(false);
    modalState.resolve = null;
  }
}
